import { useInfiniteList } from "@refinedev/core";
import { ViewerActivityEvent } from "types";
import { getNextPageParamWithServerPagination } from "utils/pagination/";

export const useActivityTimeline = ({
  projectId,
  params,
  enabled = true,
}: {
  projectId: string;
  enabled?: boolean;
  params: {
    page: number;
    size: number;
    from_date?: string;
    to_date?: string;
  };
}) => {
  const queryString = new URLSearchParams(
    Object.entries(params)
      .filter(
        ([key, value]) =>
          value !== undefined && key !== "page" && key !== "size"
      )
      .map(([key, value]) => [key, String(value)])
  );

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteList<ViewerActivityEvent>({
      resource: `analytics/projects/${projectId}/analytics/timeline?${queryString}`,
      queryOptions: {
        enabled,
        getNextPageParam: getNextPageParamWithServerPagination(params.size),
      },
      pagination: {
        pageSize: params.size,
      },
    });

  return {
    data: data?.pages,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
  };
};
